import { useSuspenseQuery } from '@apollo/client';
import React from 'react';
import { Link } from 'react-router-dom';

import {
  Button,
  ColDefBuilder,
  DataTable,
  Heading,
  Icon,
  Stack,
} from '@eluve/components';
import { graphql } from '@eluve/graphql.tada';

const getDatasetsQuery = graphql(`
  query getDatasets {
    evalDatasets {
      __typename
      id
      name
      description
      createdAt
    }
  }
`);

type ArtifactRow = {
  id: string;
  name: string | null;
  description: string | null;
  createdAt: string;
};

const columns = new ColDefBuilder<ArtifactRow>()
  .linkSortable('name', (row) => `./${row.id}`)
  .defaultSortable('description')
  .dateSortable('createdAt')
  .build();

export const DatasetsListPage: React.FC = () => {
  const {
    data: { evalDatasets: datasets },
  } = useSuspenseQuery(getDatasetsQuery);

  return (
    <div>
      <Stack justify="between" gap={2} direction="horizontal">
        <div className="flex-1">
          <div className="my-2 py-2">
            <Heading>Datasets</Heading>
          </div>
        </div>
        <Link to="create">
          <Button>
            <Icon name="Plus" size="lg" className="mr-2" />
            Create a new dataset
          </Button>
        </Link>
      </Stack>
      <DataTable
        columns={columns}
        data={datasets}
        initialSortingState={[
          {
            id: 'createdAt',
            desc: true,
          },
        ]}
      />
    </div>
  );
};
